import { cn } from '@/app/utils/cn'
import { Square, SquareCheckBig } from 'lucide-react'
import { Controller, useFormContext } from 'react-hook-form'

interface BasicOptionsProps {
  name: string
  label?: string
  options: { label: string; value: string }[]
  error?: string
}
export default function BasicOptions({
  name,
  label,
  options,
  error,
}: BasicOptionsProps) {
  const { control } = useFormContext()
  const theme = import.meta.env.VITE_THEME

  return (
    <div>
      {label && <p className="mb-2 text-sm font-medium">{label}</p>}
      <Controller
        name={name}
        control={control}
        render={({ field: { onChange, value } }) => {
          return (
            <div className="mr-8 flex gap-5">
              {options.map((op) => {
                const checked = value === op.value
                return (
                  <label
                    htmlFor={op.value}
                    onClick={() => onChange(op.value)}
                    key={op.value}
                    className={cn(
                      'flex w-full justify-between rounded-lg border-gray01 bg-white02 px-4 py-3',
                      checked &&
                        'border-primary text-primary shadow-sm shadow-primary',
                    )}
                  >
                    <span className="text-sm font-medium">{op.label}</span>
                    {checked ? (
                      <SquareCheckBig color={theme.primary} />
                    ) : (
                      <Square />
                    )}
                  </label>
                )
              })}
            </div>
          )
        }}
      />
      <p className="text-sm text-error">{error}</p>
    </div>
  )
}
